/*!
 * Here comes description.
 *
 * @package tokai-univ
 */
const $ = jQuery;

/*!
 * @deps jquery
*/

const ua = window.navigator.userAgent.toLowerCase();
const isiOS = ua.indexOf( 'iphone' ) > -1 || ua.indexOf( 'ipad' ) > -1 || ( ua.indexOf( 'macintosh' ) > -1 && 'ontouchend' in document );
const body = $( 'body' );
const prevSideMenu = $( '.side-bar-menu-control .prev-menu' );

//create sub menu title & prev control item
$( window ).on( 'load', function () {
	let submenuItem = $( '#main-sidebar.modal-side-bar .menu-item-has-children > a' );
	let sideBarMenuTitleName;
	let sideBarTitleItem;
	let prevControlItem;

	submenuItem.each( function () {
		sideBarMenuTitleName = $( this ).html();
		sideBarTitleItem = '<li class="side-bar-sub-menu-title">' + sideBarMenuTitleName + '</li>';
		prevControlItem = '<li class="prev-side-bar-list-item">前の画面に戻る</li>';
		$( this ).next( '.sub-menu' ).prepend( sideBarTitleItem );
		$( this ).next( '.sub-menu' ).append( prevControlItem );
	} );

} );

//toggle side bar menu
let scrollPosition;
$( '.js-side-bar-trigger' ).on( 'click', function () {
	const sideBarElement = $( '#main-sidebar.modal-side-bar' );
	loadCurrentSubmenu( sideBarElement );
	if ( sideBarElement.hasClass( 'active' ) ) {
		if ( isiOS ) {
			body.css( 'position', '' );
			body.css( 'top', '' );
			$( window ).scrollTop( scrollPosition );
		}
		body.removeClass( 'off' );
		sideBarResetActiveItems();
		sideBarElement.removeClass( 'active' );
	} else {
		if ( isiOS ) {
			scrollPosition = window.pageYOffset;
			body.css( 'position', 'fixed' );
			body.css( 'top', '-' + scrollPosition + 'px' );
		}
		body.addClass( 'off' );
		sideBarElement.addClass( 'active' );
	}
} );

//sub menu active
$( '#main-sidebar.modal-side-bar .menu-item-has-children > a' ).on( 'click keypress', function () {

	let childSubMenu = $( this ).next( '.sub-menu' );

	if ( ! childSubMenu.hasClass( 'current' ) ) {
		$( '#main-sidebar.modal-side-bar .current' ).removeClass( 'current' );
		childSubMenu.addClass( 'active current' );
		childSubMenu.parent().parent().addClass( 'off' );
		$( this ).addClass( 'open' );
	} else {
		currentSubmenuOff();
	}

	if ( ! prevSideMenu.hasClass( 'active' ) ) {
		prevSideMenu.addClass( 'active' );
	}

	if ( $( this ).hasClass( 'acc-open' ) ) {
		$( this ).removeClass( 'acc-open' );
		$( this ).next( '.sub-menu' ).find( '.acc-open' ).removeClass( 'acc-open' );
	} else {
		$( this ).addClass( 'acc-open' );
	}

	return false;
} );

prevSideMenu.on( 'click keypress', function () {
	currentSubmenuOff();
} );

$( document ).on( 'click keypress', '.prev-side-bar-list-item', function () {
	currentSubmenuOff();
} );

function loadCurrentSubmenu( manuNameElement ) {
	let currentMenuItems       = manuNameElement.find( '.current-menu-item:not(.current-menu-parent)' );
	if ( $.isEmptyObject( currentMenuItems[0] ) === false ) {
		let currentMenuItem        = currentMenuItems[0];
		let currentMenuItemParents = $( currentMenuItem ).parents( 'ul' );
		currentMenuItemParents.each( function ( index ) {
			if ( $( this ).hasClass( 'sub-menu' ) && index === 0 ) {
				$( this ).addClass( 'active current' );
			} else if ( $( this ).hasClass( 'sub-menu' ) && index > 0 ) {
				$( this ).addClass( 'active off' );
			} else if ( $( this ).hasClass( 'side-bar-menu-list' ) ) {
				$( this ).addClass( 'off' );
			}
		} );
	} else {
		return false;
	}
}

function currentSubmenuOff() {
	let currentItem = $( '#main-sidebar.modal-side-bar .current.active' );
	if ( currentItem.parent().parent().hasClass( 'active' ) ){
		currentItem.parent().parent().removeClass( 'off' );
		currentItem.parent().parent().addClass( 'current' );
	} else {
		prevSideMenu.removeClass( 'active' );
		currentItem.parent().parent().removeClass( 'off' );
	}
	currentItem.removeClass( 'active current' );
	$( '#main-sidebar.modal-side-bar a.open' ).removeClass( 'open' );
}

function sideBarResetActiveItems() {
	$( '#main-sidebar.modal-side-bar a.open' ).removeClass( 'open' );
	$( '#main-sidebar.modal-side-bar .active' ).removeClass( 'active' );
	$( '#main-sidebar.modal-side-bar .current' ).removeClass( 'current' );
	prevSideMenu.removeClass( 'active' );
}
